import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginComputer from '../views/LoginComputer.vue'
import Main_menuComputer from '../views/Main_menuComputer.vue'
import titleBlock_computer from '../views/titleBlock_computer.vue'
import productTable from '../views/productTable.vue'
import TableInput from '../views/TableInput.vue'
import LoginPhone from '../views/LoginPhone.vue'
import Main_menuPhone from '../views/Main_menuPhone.vue'
import productTablePhone from '../views/productTablePhone.vue'
import TableInputPhone from '../views/TableInputPhone.vue'
import OrderPlone from '../views/OrderPlone.vue'
import OrderPc from '../views/OrderPc.vue'
import NewsPc from '../views/NewsPc.vue'
import NewsPhone from '../views/NewsPhone.vue'
import FinanceComputer from '../views/FinanceComputer.vue'
import missionComputer from '../views/missionComputer.vue'
import FeiBiaoZhunChaXun from '../views/FeiBiaoZhunChaXun.vue'
import StandardMaterialMaster from '../views/StandardMaterialMaster.vue'
import NonStandardMaterialMaster from '../views/NonStandardMaterialMaster.vue'
import second_menuComputer_ICProductInfo from '../views/second_menuComputer_ICProductInfo.vue'
import second_menuComputer_PriceAndInventory from '../views/second_menuComputer_PriceAndInventory.vue'
import Main_menuPhone_JiaGeYuKuCun from '../views/Main_menuPhone_JiaGeYuKuCun.vue'
import FeiBiaoZhunProductTablePahone from '../views/FeiBiaoZhunProductTablePahone.vue'
import Main_menuPhone_WuLiaoZhuDang from '../views/Main_menuPhone_WuLiaoZhuDang.vue'
import SrandardMaterialMasterPhone from '../views/SrandardMaterialMasterPhone.vue'
import NonStandardMaterialMasterPhone from '../views/NonStandardMaterialMasterPhone.vue'
import FinancePhone from '../views/FinancePhone.vue'
import missionPhone from '../views/missionPhone.vue'
import ICChanPinXinXi from '../views/ICChanPinXinXi.vue'
import ICChanPinXinXi_phone from '../views/ICChanPinXinXi_phone.vue'
import CompetitionRegistration from '../views/CompetitionRegistration.vue'
import CompetitionRegistrationInput from '../views/CompetitionRegistrationInput.vue'
import second_menuComputer_JingPin from '../views/second_menuComputer_JingPin.vue'
import Competition_table from '../views/Competition_table.vue'
import Main_menuPhone_JingPingDengJi from '../views/Main_menuPhone_JingPingDengJi.vue'
import CompetitionRegistration_phone from '../views/CompetitionRegistration_phone.vue'
import CompetitionRegistrationInput_phone from '../views/CompetitionRegistrationInput_phone.vue'
import CompetitionRegistrationInfo from '../views/CompetitionRegistrationInfo.vue'
import CompetitionRegistrationInfo_phone from '../views/CompetitionRegistrationInfo_phone.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/missionPhone',
    name: 'missionPhone',
    component: missionPhone
  },
  {
    path: '/CompetitionRegistrationInfo_phone',
    name: 'CompetitionRegistrationInfo_phone',
    component: CompetitionRegistrationInfo_phone
  },
  {
    path: '/OrderPc',
    name: 'OrderPc',
    component: OrderPc
  },
  {
    path: '/NewsPc',
    name: 'NewsPc',
    component: NewsPc
  },
  {
    path: '/NewsPhone',
    name: 'NewsPhone',
    component: NewsPhone
  },
  {
    path: '/CompetitionRegistrationInfo',
    name: 'CompetitionRegistrationInfo',
    component: CompetitionRegistrationInfo
  }, {
    path: '/CompetitionRegistrationInput_phone',
    name: 'CompetitionRegistrationInput_phone',
    component: CompetitionRegistrationInput_phone
  },
  {
    path: '/CompetitionRegistration_phone',
    name: 'CompetitionRegistration_phone',
    component: CompetitionRegistration_phone
  },
  {
    path: '/Main_menuPhone_JingPingDengJi',
    name: 'Main_menuPhone_JingPingDengJi',
    component: Main_menuPhone_JingPingDengJi
  }, {
    path: '/Competition_table',
    name: 'Competition_table',
    component: Competition_table
  },
  {
    path: '/second_menuComputer_JingPin',
    name: 'second_menuComputer_JingPin',
    component: second_menuComputer_JingPin
  }, {
    path: '/NonStandardMaterialMasterPhone',
    name: 'NonStandardMaterialMasterPhone',
    component: NonStandardMaterialMasterPhone
  },
  {
    path: '/FinancePhone',
    name: 'FinancePhone',
    component: FinancePhone
  },
  {
    path: '/CompetitionRegistrationInput',
    name: 'CompetitionRegistrationInput',
    component: CompetitionRegistrationInput
  },  {
    path: '/SrandardMaterialMasterPhone',
    name: 'SrandardMaterialMasterPhone',
    component: SrandardMaterialMasterPhone
  },
  {
    path: '/Main_menuPhone_WuLiaoZhuDang',
    name: 'Main_menuPhone_WuLiaoZhuDang',
    component: Main_menuPhone_WuLiaoZhuDang
  },
  {
    path: '/FeiBiaoZhunProductTablePahone',
    name: 'FeiBiaoZhunProductTablePahone',
    component: FeiBiaoZhunProductTablePahone
  },
  {
    path: '/Main_menuPhone_JiaGeYuKuCun',
    name: 'Main_menuPhone_JiaGeYuKuCun',
    component: Main_menuPhone_JiaGeYuKuCun
  },
  {
    path: '/second_menuComputer_PriceAndInventory',
    name: 'second_menuComputer_PriceAndInventory',
    component: second_menuComputer_PriceAndInventory
  },
  {
    path: '/second_menuComputer_ICProductInfo',
    name: 'second_menuComputer_ICProductInfo',
    component: second_menuComputer_ICProductInfo
  },
  {
    path: '/NonStandardMaterialMaster',
    name: 'NonStandardMaterialMaster',
    component: NonStandardMaterialMaster
  },
  {
    path: '/StandardMaterialMaster',
    name: 'StandardMaterialMaster',
    component: StandardMaterialMaster
  },
  {
    path: '/FeiBiaoZhunChaXun',
    name: 'FeiBiaoZhunChaXun',
    component: FeiBiaoZhunChaXun
  },
  {
    path: '/TableInputPhone',
    name: 'TableInputPhone',
    component: TableInputPhone
  },
  {
    path: '/OrderPlone',
    name: 'OrderPlone',
    component: OrderPlone
  },
  {
    path: '/missionComputer',
    name: 'missionComputer',
    component: missionComputer
  },
  {
    path: '/FinanceComputer',
    name: 'FinanceComputer',
    component: FinanceComputer
  },
  {
    path: '/productTable',
    name: 'productTable',
    component: productTable
  },
  {
    path: '/productTablePhone',
    name: 'productTablePhone',
    component: productTablePhone
  },
  {
    path: '/Main_menuPhone',
    name: 'Main_menuPhone',
    component: Main_menuPhone
  },
  {
    path: '/LoginPhone',
    name: 'LoginPhone',
    component: LoginPhone
  },
  {
    path: '/TableInput',
    name: 'TableInput',
    component: TableInput
  },
  {
    path: '/titleBlock_computer',
    name: 'titleBlock_computer',
    component: titleBlock_computer
  },
  {
    path: '/',
    name: 'LoginComputer',
    component: LoginComputer
  },
  {
    path: '/Main_menuComputer',
    name: 'Main_menuComputer',
    component: Main_menuComputer
  },
  {
    path: '/ICChanPinXinXi',
    name: 'ICChanPinXinXi',
    component: ICChanPinXinXi
  },
  {
    path: '/ICChanPinXinXi_phone',
    name: 'ICChanPinXinXi_phone',
    component: ICChanPinXinXi_phone
  },{
    path: '/CompetitionRegistration',
    name: 'CompetitionRegistration',
    component: CompetitionRegistration
  },

]
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router